"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _unmutable = _interopRequireDefault(require("./internal/unmutable"));

var _clear = _interopRequireDefault(require("./clear"));

var _pick = _interopRequireDefault(require("./pick"));

var _merge = _interopRequireDefault(require("./merge"));

var _reduce = _interopRequireDefault(require("./reduce"));

var _pipeWith = _interopRequireDefault(require("./util/pipeWith"));

var _isValueObject = _interopRequireDefault(require("./util/isValueObject"));

var getDepth = function getDepth(depthOrShallow) {
  if (!depthOrShallow) {
    return Number.POSITIVE_INFINITY;
  }

  if (depthOrShallow === true) {
    return 1;
  }

  return depthOrShallow;
};

var _default = (0, _unmutable.default)({
  name: 'flatten',
  immutable: 'flatten',
  all: function all(depthOrShallow) {
    return function (value) {
      var depth = getDepth(depthOrShallow);

      for (var i = 0; i < depth; i++) {
        var hasGrandchildren = false;
        value = (0, _pipeWith.default)(value, (0, _reduce.default)(function (reduced, child, key) {
          var toMerge;

          if ((0, _isValueObject.default)(child)) {
            toMerge = child;
            hasGrandchildren = true;
          } else {
            toMerge = (0, _pick.default)([key])(value);
          }

          return (0, _merge.default)(toMerge)(reduced);
        }, (0, _clear.default)()(value)));

        if (!hasGrandchildren) {
          break;
        }
      }

      return value;
    };
  }
});

exports.default = _default;